import { render, staticRenderFns } from "./projectTaskDialog.vue?vue&type=template&id=753936b8&"
import script from "./projectTaskDialog.vue?vue&type=script&lang=ts&"
export * from "./projectTaskDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports